import {
    getAbsenceTypes,
    getScheduleRequests,
    createScheduleRequest,
    getAvailabilityRequests,
    updateScheduleRequest,
    deleteScheduleRequest,
} from '../../services/scheduleRequestService';

export async function fetchAbsenceTypes(dispatch) {
    try {
        dispatch({ type: 'REQUEST_SCHEDULE' });
        const response = await getAbsenceTypes();
        if (response.data) {
            dispatch({ type: 'ABSENCE_TYPES_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'SCHEDULE_ERROR', payload: 'Failed to load absence types.' });
    } catch (error) {
        dispatch({ type: 'SCHEDULE_ERROR', payload: error?.message || 'Failed to load absence types.' });
    }
}

export async function fetchScheduleRequests(dispatch) {
    try {
        dispatch({ type: 'REQUEST_SCHEDULE' });
        const response = await getScheduleRequests();
        if (response.data) {
            dispatch({ type: 'SCHEDULE_REQUESTS_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'SCHEDULE_ERROR', payload: 'Failed to load schedule requests.' });
    } catch (error) {
        dispatch({ type: 'SCHEDULE_ERROR', payload: error?.message || 'Failed to load schedule requests.' });
    }
}

export async function submitScheduleRequest(dispatch, payload) {
    try {
        dispatch({ type: 'REQUEST_SCHEDULE' });
        const response = await createScheduleRequest(payload);
        if (response.data) {
            dispatch({ type: 'CREATE_SCHEDULE_REQUEST_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'SCHEDULE_ERROR', payload: 'Failed to submit request.' });
    } catch (error) {
        dispatch({ type: 'SCHEDULE_ERROR', payload: error?.message || 'Failed to submit request.' });
        throw error;
    }
}

export async function fetchAvailabilityRequests(dispatch) {
    try {
        dispatch({ type: 'REQUEST_SCHEDULE' });
        const response = await getAvailabilityRequests();
        if (response.data) {
            dispatch({ type: 'AVAILABILITY_REQUESTS_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'SCHEDULE_ERROR', payload: 'Failed to load availability requests.' });
    } catch (error) {
        dispatch({ type: 'SCHEDULE_ERROR', payload: error?.message || 'Failed to load availability requests.' });
    }
}

export async function submitAvailabilityRequest(dispatch, payload) {
    try {
        dispatch({ type: 'REQUEST_SCHEDULE' });
        const response = await createScheduleRequest(payload);
        if (response.data) {
            dispatch({ type: 'CREATE_AVAILABILITY_REQUEST_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'SCHEDULE_ERROR', payload: 'Failed to submit availability request.' });
    } catch (error) {
        dispatch({ type: 'SCHEDULE_ERROR', payload: error?.message || 'Failed to submit availability request.' });
        throw error;
    }
}

export async function editScheduleRequest(dispatch, id, payload) {
    try {
        dispatch({ type: 'REQUEST_SCHEDULE' });
        const response = await updateScheduleRequest(id, payload);
        if (response.data) {
            dispatch({ type: 'UPDATE_SCHEDULE_REQUEST_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'SCHEDULE_ERROR', payload: 'Failed to update request.' });
    } catch (error) {
        dispatch({ type: 'SCHEDULE_ERROR', payload: error?.message || 'Failed to update request.' });
        throw error;
    }
}

export async function cancelScheduleRequest(dispatch, id) {
    try {
        dispatch({ type: 'REQUEST_SCHEDULE' });
        const response = await deleteScheduleRequest(id);
        if (response.data) {
            dispatch({ type: 'DELETE_SCHEDULE_REQUEST_SUCCESS', payload: parseInt(response.data.id, 10) });
            return response.data;
        }
        dispatch({ type: 'SCHEDULE_ERROR', payload: 'Failed to cancel request.' });
    } catch (error) {
        dispatch({ type: 'SCHEDULE_ERROR', payload: error?.message || 'Failed to cancel request.' });
        throw error;
    }
}
